/* eslint camelcase: 0 */

/**
 * Extention for web3.js. Adds the namespace "energi" to web3.
 * Public API extension
 *
 *
 * Web3 = require('web3');<br>
 * web3Extension = require('@energi/web3-ext');<br>
 *
 * web3 = new Web3('https://nodeapi.test3.energi.network');<br>
 * web3Extension(web3);<br>
 * result = await web3.energi.budgetInfo();<br>
 *
 *
 * <br>
 * <i>Copyright (c) 2020 Energi Cryptocurrency - https://energi.world</i><br>
 * BSD-3-Clause License
 *
 *
 * @module energi.js
 * @extends web3
 * @class web3.energi
 * @since 0.0.1
*/
var extend = function extend(web3) {
  var toBN = web3.utils.toBN;

  web3.extend.formatters.outputProposalFormatter = function (item) {
    if (!item) {
      return null; // force the same output as on a node
    }

    return {
      proposal: item.Proposal,
      proposer: item.Proposer,
      createdBlock: item.CreatedBlock,
      deadline: new Date(1000 * item.Deadline),
      quorumWeight: toBN(item.QuorumWeight),
      totalWeight: toBN(item.TotalWeight),
      rejectWeight: toBN(item.RejectWeight),
      acceptWeight: toBN(item.AcceptWeight),
      finished: item.Finished,
      accepted: item.Accepted,
      balance: toBN(item.Balance),
      refUUID: item.RefUUID,
      proposedAmount: toBN(item.ProposedAmount || '0'),
      paidAmount: toBN(item.PaidAmount || '0')
    };
  };

  web3.extend.formatters.outputGen2CoinFormatter = function (item) {
    if (item) {
      return {
        amount: toBN(item.Amount),
        itemId: item.ItemID,
        owner: item.Owner,
        rawOwner: item.RawOwner
      };
    }
  };

  web3.extend.formatters.outputCoinFormatter = function (item) {
    if (item) {
      item.amount = toBN(item.Amount);
      delete item.Amount;
      return item;
    }
  };

  var outputProposalFormatter = web3.extend.formatters.outputProposalFormatter,
      outputGen2CoinFormatter = web3.extend.formatters.outputGen2CoinFormatter,
      outputCoinFormatter = web3.extend.formatters.outputCoinFormatter;
  web3.extend({
    property: 'energi',
    methods: [
    /**
     * Returns the blacklist
     *
     * @method blacklistInfo
     * @return {Array}
     * @since 0.0.1
     */
    new web3.extend.Method({
      name: 'blacklistInfo',
      call: 'energi_blacklistInfo',
      params: 0,
      outputFormatter: function outputFormatter(item) {
        return {
          target: item.Target,
          enforce: outputProposalFormatter(item.Enforce),
          revoke: outputProposalFormatter(item.Revoke),
          drain: outputProposalFormatter(item.Drain),
          blocked: item.Blocked
        };
      }
    }),
    /**
     * Returns a list of proposals and the available balance
     *
     * @method budgetInfo
     * @return {Object}
     * @since 0.0.1
     */
    new web3.extend.Method({
      name: 'budgetInfo',
      call: 'energi_budgetInfo',
      params: 0,
      outputFormatter: function outputFormatter(status) {
        return {
          balance: toBN(status.Balance),
          proposals: status.Proposals.map(outputProposalFormatter)
        };
      }
    }),
    /**
     * Returns a list of compensations and available balance
     *
     * @method compensationInfo
     * @return {Object}
     * @since 0.0.1
     */
    new web3.extend.Method({
      name: 'compensationInfo',
      call: 'energi_compensationInfo',
      params: 0,
      outputFormatter: function outputFormatter(status) {
        return {
          balance: toBN(status.Balance),
          proposals: status.Proposals.map(outputProposalFormatter)
        };
      }
    }),
    /**
     * Searches for Gen2 coin info
     *
     * @method searchGen2Coins
     * @return {Array}
     * @since 0.0.1
     */
    new web3.extend.Method({
      name: 'searchGen2Coins',
      call: 'energi_searchGen2Coins',
      params: 2,
      outputFormatter: outputGen2CoinFormatter
    }),
    /**
     * Searches for the Gen3 destination address for a given Gen2 address
     *
     * @method searchGen3DestinationByGen2Address
     * @return {String}
     * @since 0.0.1
     */
    new web3.extend.Method({
      name: 'searchGen3DestinationByGen2Address',
      call: 'energi_searchGen3DestinationByGen2Address',
      params: 2,
      outputFormatter: outputCoinFormatter
    }),
    /**
     * Searches for Gen2 coin info
     *
     * @method searchRawGen2Coins
     * @return {Array}
     * @since 0.0.1
     */
    new web3.extend.Method({
      name: 'searchRawGen2Coins',
      call: 'energi_searchRawGen2Coins',
      params: 2,
      outputFormatter: outputGen2CoinFormatter
    }),
    /**
     * Returns the upgrade info
     *
     * @method upgradeInfo
     * @return {Object}
     * @since 0.0.1
     */
    new web3.extend.Method({
      name: 'upgradeInfo',
      call: 'energi_upgradeInfo',
      params: 0,
      outputFormatter: function outputFormatter(status) {
        var upgradeInfo = {};
        var keys = Object.keys(status);
        keys.forEach(function (key) {
          var keyLowercased = key[0].toLowerCase() + key.substr(1);
          upgradeInfo[keyLowercased] = status[key].map(function (item) {
            var modifiedItem = outputProposalFormatter(item);
            modifiedItem.impl = item.Impl;
            modifiedItem.proxy = item.Proxy;
            return modifiedItem;
          });
        });
        return upgradeInfo;
      }
    })]
  });
};

module.exports = extend;